import { InputFileSource } from '../types';
import { RECORDER_INPUT_FILE_SOURCES } from './media/sessionRecordingsDatabase.utils';

export type StorageMetadata = {
    quota: number;
    usage: number;
    storageUsageRatio: number;
    remainingStorage: number;
};

export const getStorageEstimate = async (): Promise<
    StorageMetadata | undefined
> => {
    try {
        const storageEstimate = await window.navigator.storage.estimate();

        if (
            storageEstimate.quota === undefined ||
            storageEstimate.usage === undefined
        ) {
            return;
        }

        const storageUsageRatio =
            (storageEstimate.usage / storageEstimate.quota) * 100;

        return {
            quota: storageEstimate.quota,
            usage: storageEstimate.usage,
            remainingStorage: storageEstimate.quota - storageEstimate.usage,
            storageUsageRatio,
        };
    } catch {
        // ignore
    }
};

export const isStorageRelevantToSessionWorkflow = (
    sessions: Array<{ inputFileSource: InputFileSource }>,
) =>
    sessions.some((session) =>
        RECORDER_INPUT_FILE_SOURCES.includes(session.inputFileSource),
    );
